import { useEffect } from 'react';

export const HealthCheck = () => {
  useEffect(() => {
    // Set document title for health check
    document.title = 'Health Check - OK';
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="bg-white p-8 rounded-lg shadow-lg max-w-md w-full">
        <h1 className="text-2xl font-bold text-green-600 mb-4">Health Check</h1>
        <div className="space-y-2">
          <p><span className="font-semibold">Status:</span> <span className="text-green-600">Healthy</span></p>
          <p><span className="font-semibold">Timestamp:</span> {new Date().toISOString()}</p>
          <p><span className="font-semibold">App:</span> askiimall-marketplace</p>
        </div>
        <div className="mt-6 p-4 bg-gray-100 rounded text-sm font-mono" data-testid="health-check">
          {JSON.stringify({
            status: 'healthy',
            timestamp: new Date().toISOString(),
            app: 'askiimall-marketplace'
          }, null, 2)}
        </div>
      </div>
    </div>
  );
};